import { Injectable } from '@angular/core';
import { ExemptionReasonEnum } from '../types/ExemptionReasonEnum';
import { KeyValue } from '@angular/common';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { AppConfigService } from 'src/app/app-config.service';

@Injectable({
	providedIn: 'root'
})
export class ReferenceDataService {
	constructor(private http: HttpClient, private configService: AppConfigService) {}

	//TODO: make this a statefull service for some elements

	/**
     * Takes a type (assumed to be an enum) and returns a key/value array with:
     *    key = number value of enum item
     *    value = string keyword if the enum item
     * @param t
     */
	getEnumAsKeyValues<T>(t: T): KeyValue<any, string>[] {
		return Object.keys(t).filter((value) => isNaN(Number(value)) === false).map((key) => ({
			key: +key,
			value: t[key].replace(/([A-Z0-9])/g, ' $1').trim()
		}));
	}

	getStateList(): Observable<KeyValue<any, string>[]> {
		return this.http.get<KeyValue<number, string>[]>(`${this.configService.getConfig().registrantApiUrl}/usStates`);
	}

	getInsuranceCompanyList(): Observable<KeyValue<number, string>[]> {
		return this.http.get<KeyValue<number, string>[]>(
			`${this.configService.getConfig().registrantApiUrl}/insuranceCompanies`
		);
	}

	getExemptionReasonOptions(hasTag: boolean, mliRecordId: string): Observable<KeyValue<any, string>[]> {
		var parameters = new HttpParams();
		parameters = parameters.append('hasTag', hasTag.toString());
		parameters = parameters.append('mliRecordId', mliRecordId);

		return this.http.get<KeyValue<number, string>[]>(
			`${this.configService.getConfig().registrantApiUrl}/exemptionReasons`,
			{
				params: parameters
			}
		);
	}

	getDocumentTypeOptions(exemptionReason: ExemptionReasonEnum = null) {
		var params = exemptionReason
			? new HttpParams().append('exemptionReason', exemptionReason.toString())
			: new HttpParams();

		return this.http.get<KeyValue<number, string>[]>(
			`${this.configService.getConfig().registrantApiUrl}/documentList`,
			{
				params: params
			}
		);
	}
}
